
import React, { useState } from 'react'
import PostPhotoGalleryItem from './PostPhotoGalleryItem';
import PostPhotoGalleryController from '../controller/PostPhotoGalleryController';
import Gallery from 'cms/pages/Gallery';

function PostPhotoGallery({ id }) {

    const [, forceUpdate] = useState();

    const { savePostPhotoGallery,photoGalleries,setPhotoGalleries, setAddModalIsOpen, addModalIsOpen, closeModal,refetch} = PostPhotoGalleryController(id)

    return (
        <div className="box box-primary">
            <div className="box-header with-border">
                <div className="text-color-light flex-space-between mb-4 ">
                    <h3 className="box-title">Image Gallery</h3>
                    <button className="btn btn-dark pull-right" onClick={() => { setAddModalIsOpen(true) }}><i className="fa fa-plus"></i></button>
                </div>
            </div>
            <div className="box-body padding-20 ">
                {photoGalleries && photoGalleries.map(item => (
                    <PostPhotoGalleryItem key={item.id} item={item} 
                        onDelete={(id) => {
                            setPhotoGalleries((photoGalleries) => photoGalleries.filter(item => item.id !== id));
                            forceUpdate({});
                        }} />
                )
                )}
            </div>

            <Gallery onImageSelected={(url)=>{ savePostPhotoGallery(url) }} isOpen={addModalIsOpen} key={addModalIsOpen+"ig"}
             closeGallery={() => { closeModal()}} />
            
        </div>
    )
}

export default PostPhotoGallery